// extracted by mini-css-extract-plugin
export default {"deliverySection":"Delivery_deliverySection__aJvi+","deliveryInfo":"Delivery_deliveryInfo__YImFw"};